import { IFilterCategoryDef, IFilterDef, IFilterDefWithOptions, IFilterDefWithTypeahead, SelectOption } from "../../shared/interfaces/IFilterDef";
import { TypeaheadItem } from "../typeahead/typeahead.component";
import { VendorSearchDropdowns } from "./types/VendorSearchDropdowns";
import { VendorSearchParameters } from "./types/VendorSearchParameters";

var namedFilters = {
  ContactName: <IFilterDef<VendorSearchParameters>>{ name: "Contact Name", inputType: "text", hintText: "Executes a 'contains' search", searchParameterProperty: "ContactName" },
  VendorCode: <IFilterDef<VendorSearchParameters>>{ name: "Vendor Code", inputType: "text", hintText: "Executes a 'contains' search", searchParameterProperty: "VendorCode" },
  VendorName: <IFilterDef<VendorSearchParameters>>{ name: "Vendor Name", inputType: "text", hintText: "Executes a 'contains' search", searchParameterProperty: "VendorName" },
  Countries: <IFilterDefWithTypeahead<number, VendorSearchParameters>>{ name: "Vendor Country", inputType: "autocomplete", options: [], searchParameterProperty: "CountryIds" },
  PersonResponsibles: <IFilterDefWithTypeahead<number, VendorSearchParameters>>{ name: "Person Responsible", inputType: "autocomplete", options: [], searchParameterProperty: "PersonResponsibleIds" },
  BudgetYears: <IFilterDefWithOptions<number, VendorSearchParameters>>{ name: "Budget Years", inputType: "selectMulti", options: [], searchParameterProperty: "BudgetYears" },
  Years: <IFilterDefWithOptions<number, VendorSearchParameters>>{ name: "Years", inputType: "selectMulti", options: [], searchParameterProperty: "Years" },
  VendorZip: <IFilterDef<VendorSearchParameters>>{ name: "Vendor Zip Code", inputType: "text", hintText: "Executes a 'contains' search", searchParameterProperty: "VendorZip" },
  VendorActive: <IFilterDefWithOptions<boolean, VendorSearchParameters>>{ name: "Vendor Active", inputType: "selectSingle", options: [], searchParameterProperty: "VendorActive" },
  TrialNontrialNumber: <IFilterDef<VendorSearchParameters>>{ name: "Number", inputType: "text", hintText: "Executes a 'contains' search", searchParameterProperty: "TrialNontrialNumber" }
}

var filterCategories: IFilterCategoryDef<VendorSearchParameters>[] = [
  {
    categoryName: "Vendor",
    filters: [
      namedFilters.VendorName,
      namedFilters.VendorCode,
      namedFilters.Countries,
      namedFilters.VendorZip,
      namedFilters.VendorActive

    ]
  },
  {
    categoryName: "Contact",
    filters: [
      namedFilters.ContactName
    ]
  },
  {
    categoryName: "Trial/Non Trial",
    filters: [
      namedFilters.PersonResponsibles,
      namedFilters.Years,
      namedFilters.BudgetYears,
      namedFilters.TrialNontrialNumber
    ]
  }
];

var filters: IFilterDef<VendorSearchParameters>[] = [
  namedFilters.VendorName,
  namedFilters.VendorCode,
  namedFilters.Countries,
  namedFilters.VendorZip,
  namedFilters.ContactName,
  namedFilters.PersonResponsibles,
  namedFilters.BudgetYears,
  namedFilters.Years,
  namedFilters.VendorActive,
  namedFilters.TrialNontrialNumber
]

export var filterDefinitions = {
  namedFilters: namedFilters,
  filterCategories: filterCategories,
  filters: filters,
  mapFiltersFromApi: (response: VendorSearchDropdowns) => {
    namedFilters.Countries.options = response.Countries.map(a => <TypeaheadItem<number>>{
      DisplayText: a.CountryName,
      Item: a.CountryId
    });
    namedFilters.PersonResponsibles.options = response.PersonResponsibles.map(a => <TypeaheadItem<number>>{
        DisplayText: a.LastName + ", " + a.FirstName,
        Item: a.Id
    });
    namedFilters.BudgetYears.options = response.BudgetYears.map(a => <SelectOption<number>>{ display: a.toString(), value: a });
    namedFilters.Years.options = response.Years.map(a => <SelectOption<number>>{ display: a.toString(), value: a });
    namedFilters.VendorActive.options = [{ display: "Yes", value: true }, { display: "No", value: false }];
  }
}
